import { render, staticRenderFns } from "./SmartchatIcon.vue?vue&type=template&id=6d56c858&"
import script from "./SmartchatIcon.vue?vue&type=script&lang=js&"
export * from "./SmartchatIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports